export const canManageClientAccount = (role: unknown): boolean => role === 'owner' || role === 'admin';
